import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ShippingStateType = {
  _id: string;
  origin_customer_data: {
    sender_name: string;
    sender_phone: string;
    sender_address: string;
  };
  destination_customer_data: {
    recipient_name: string;
    recipient_phone: string;
    recipient_address: string;
  };
  shipping_date: string;
  shipping_number: string;
  status_code: string;
  status_label: string;
  quantity: number;
  weight_kg: number;
  item_unit: string;
  total_price: number;
  payment_status: string;
  origin_office_id: {
    _id: string;
    city: string;
    branch_name: string;
  };
  destination_office_id: {
    _id: string;
    city: string;
    branch_name: string;
  };
};

type FetchShippingListResponse = {
  data: ShippingStateType[];
  totalData: number;
  totalPage: number;
};

interface ShippingState {
  data_list: ShippingStateType[];
  totalData: number;
  totalPage: number;
}

const initialState: ShippingState = {
  data_list: [],
  totalData: 0,
  totalPage: 1,
};

export const shippingSlice = createSlice({
  name: "shipping",
  initialState,
  reducers: {
    setShippingListData: (state, action: PayloadAction<FetchShippingListResponse>) => {
      const { totalData, totalPage, data } = action.payload;
      state.data_list = data;
      state.totalData = totalData;
      state.totalPage = totalPage;
    },
    clearShippingListData: (state) => {
      state.data_list = [];
      state.totalData = 0;
      state.totalPage = 1;
    },
  },
});

export const { setShippingListData, clearShippingListData } = shippingSlice.actions;

export default shippingSlice.reducer;
